import ImageCard from './ImageCard';
import { useInfiniteScroll } from '../hooks/useInfiniteScroll';
import ShimmerLoader from './ShimmerLoader';

// Grid layout for images with shimmer loading
const ImageGrid = ({ images, onImageClick, onDownload, onLoadMore, hasMore, isLoading }) => {
  const observerTarget = useInfiniteScroll(onLoadMore, hasMore && !isLoading);

  if (images.length === 0 && !isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <div className="text-5xl mb-4">🔍</div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
          No Images Found
        </h3>
        <p className="text-gray-600 dark:text-gray-400 text-sm">
          Try adjusting your search or explore different categories
        </p>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* Grid - Responsive columns with better spacing */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
        {images.map((image) => (
          <ImageCard
            key={image.id}
            image={image}
            onImageClick={onImageClick}
            onDownload={onDownload}
          />
        ))}
      </div>

      {/* Shimmer loading skeleton */}
      {isLoading && <ShimmerLoader count={4} className="mt-6" />}

      {/* Infinite Scroll Trigger */}
      {hasMore && <div ref={observerTarget} className="h-10 mt-6" />}
    </div>
  );
};

export default ImageGrid;
